<template>
  <div>
    <div>
      <!-- 使用组件 -->
      <MemberInfo></MemberInfo>
    </div>
    <div class="header-centers">
      <div>
        <el-card class="NumberCardWidth">
          <div class="deal flex-between">
            <div class="card-text">
              <h3>会员关系</h3>
            </div>
            <div class="card-button">
              <el-button
                class="push-button"
                icon="iconfont icon-fanhui"
                @click="NvagetToLookMenber"
                plain
                >返回基本信息</el-button
              >
            </div>
          </div>
          <div class="NumberTable">
            <!-- table列表 -->
            <Table
              @TouchTheBottom="TouchTheBottom"
              :PagesData="paging"
              :tableData="list.tbody"
              :configTable="list.thead"
              :config="list"
            ></Table>
          </div>
        </el-card>
      </div>
      <!-- 右侧列表相关链接 -->
      <!-- 使用封装的组件 -->
      <div class="PagesContentRight">
        <RightCard></RightCard>
      </div>
    </div>
  </div>
</template>

<script>
import {mapState} from "vuex"
import {
  GetSelectByCustIDs
} from "@/api/viewMemberModule";
import { getcpyNo } from "@/utils/auth";
import Table from "/src/components/NumberTable/index.vue";
export default {
  name: "centre",
  components: {
    Table: Table,
  },
  data() {
    return {
      paging: {
        page: 1,
        size: 50,
        total: 0,
        pages: 2,
        Loading: true,
      },
      list: {
        thead: [
          //设置表头
          {
            label: "",
            prop: "CopyIndex",
            width: 50,
          },
          {
            label: "会员关系",
            prop: "bindCustName",
          },
          {
            label: "关系",
            prop: "relation",
          },
          {
            label: "关系类型",
            prop: "relationType",
          },
          {
            label: "创建人",
            prop: "createUserName",
          },
          {
            label: "创建时间",
            prop: "createTimeStr",
            width: 200,
          },
          {
            label: "最后修改人",
            prop: "updateUserName",
          },
          {
            label: "最后修改时间",
            prop: "updateTimeStr",
            width: 200,
          },
        ],
        tbody: [],
      },
    };
  },
  computed: {
    ...mapState({
      custID: (state) => state.user.custID,
    }),
  },
  created() {
    this.RGetSelectByCustIDs();
  },
  methods: {
    RGetSelectByCustIDs() {
      let data = require("qs").stringify({
        cpyNo: getcpyNo,
        custID: this.custID,
        pageSize: this.paging.size,
        pageNo: this.paging.page,
      });
      GetSelectByCustIDs(data).then((res) => {
        if (res.success) {
          if (res.data.list.length > 0) {
            this.paging.total = res.data.total;
            this.paging.pages = res.data.pages;
            res.data.list.forEach((item, index) => {
              item.CopyIndex =
                (this.paging.page - 1) * this.paging.size + index + 1;
              item.relationType=item.relationType==0?'主动':item.relationType==1?'被动':''
            });
            this.list.tbody =this.list.tbody.concat(res.data.list);
          }else{
            this.paging.pages = 0;
          }
        } else {
          this.$message.error(res.message);
        }
        this.paging.Loading = false;
      });
    },
    renderTime(date) {
      if (date != null) {
        var dateee = new Date(date).toJSON();
        return new Date(+new Date(dateee) + 8 * 3600 * 1000)
          .toISOString()
          .replace(/T/g, " ")
          .replace(/\.[\d]{3}Z/, "");
      } else {
        return "";
      }
    },
    TouchTheBottom() {
      this.paging.page++;
      this.RGetSelectByCustIDs();
    },
    NvagetToLookMenber() {
      this.$router.push("/LookMember");
    },
  },
};
</script>
<style lang="scss" scoped>
.NumberCardWidth{
  width: 1265px;
}
.header-centers {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top: 10px;
}
.PagesContentRight {
  height: 990px;
  margin-left: 25px;
  display: flex;
  flex-direction: column;
  justify-self: flex-start;
  align-content: flex-start;
}
.NumberTable {
  margin-top: 40px;
}
.card-text {
  color: #a19b5a;
}
.push-button {
  background-color: #e9e7d3;
  border-radius: 7px;
  color: #a19b59;
}
</style>
